export const OrderStatusLabel = {
  Canceled: 'canceled',
  CancelRequested: 'cancelRequested',
  Closed: 'closed',
  Completed: 'completed',
  Delivered: 'delivered',
  Dispatched: 'dispatched',
  New: 'new',
  Processing: 'processing',
  ReadyForPickup: 'readyForPickup',
  Shipped: 'shipped',
  WaitingForPrepayment: 'waitingForPrepayment',
} as const

export type OrderStatusConfigLabels =
  (typeof OrderStatusLabel)[keyof typeof OrderStatusLabel]

export enum ORDER_STATUS_TRANSLATIONS {
  CANCEL_REQUESTED = 'account.orders.cancel.status.requested',
  CANCELED = 'account.orders.status.canceled',
  CLOSED = 'account.orders.status.closed',
  COMPLETED = 'account.orders.status.completed',
  DISPATCHED = 'account.orders.status.dispatched',
  NEW = 'account.orders.status.new',
  PROCESSING = 'account.orders.status.processing',
  READY_FOR_PICKUP = 'account.orders.status.readyForPickup',
  WAITING_FOR_PREPAYMENT = 'account.orders.status.waitingForPrepayment',
}

export enum ORDER_STATUS_ENUM {
  CANCEL_REQUESTED = 'cancelRequested',
  CANCELED = 'canceled',
  CLOSED = 'closed',
  COMPLETED = 'completed',
  DISPATCHED = 'dispatched',
  PROCESSING = 'processing',
  READY_FOR_PICKUP = 'readyForPickup',
}

export type OrderStatusProps = {
  color: string
  lastOrderOrderStatus: OrderStatusConfigLabels
  message: string | undefined
}

export type AccountOverviewOrderStatusWithDate = {
  deliveryDate?: string
  isNowOrder?: boolean
  orderStatus: OrderStatusConfigLabels
  shippingStatusLabels: Record<OrderStatusConfigLabels, string>
  timeRange?: string
}
